import { FC, useMemo } from 'react';
import { useAtomValue } from 'jotai';
import { $CurrentArticle } from '@article/shared/atoms/current-article';
import { useArticleTitle } from '@article/shared/utils/use-article-title';
import { useArticleDescription } from '@article/shared/utils/use-article-description';
import {
  ArticleDetailUtil,
  EArticleClass,
  IGalleryArticleDetail,
  IRichArticleDetail,
  IVideoArticleDetail,
} from 'shared/models';

export const ArticleTwitter: FC = () => {
  const article = useAtomValue($CurrentArticle);

  const title = useArticleTitle();
  const description = useArticleDescription();

  const imageMeta = useMemo(() => {
    if (!ArticleDetailUtil.isArticleAvailable(article)) {
      return null;
    }
    const { articleClass } = article;
    if (articleClass === EArticleClass.GALLERY) {
      return (article as IGalleryArticleDetail).imageList[0];
    }
    return (article as IVideoArticleDetail | IRichArticleDetail).largeImage;
  }, []);

  return (
    <>
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@lemon8" />
      <meta name="twitter:text:title" content={title} />
      <meta name="twitter:description" content={description} />
      {imageMeta && <meta name="twitter:image" content={imageMeta.url} />}
    </>
  );
};
